<template>
  <div class="diagram">
    <!-- 1.创建画布 -->
    <div
      :style="{ height: height + 'px', width: width + 'px' }"
      ref="diagram"
      class="scroll"
    ></div>
    <div v-show="isOverview" ref="overview" class="overview"></div>
  </div>
</template>

<script>
export default {
  name: "diagram",
  data() {
    return {
      height: 0,
      width: 0,
      diagram: null,
      overview: null,
    };
  },
  props: {
    modelData: {
      type: Object,
    },
    isOverview: {
      type: Boolean,
      default: true,
    },
    app: null,
    edit: {
      type: Boolean,
      default: true
    },
    isReadOnly: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  watch: {
    modelData: function(val) {
      console.log("modelData:", val);
      this.diagram && this.updateModel(val);
    },
    isReadOnly: function(val) {
      this.diagram.isReadOnly = val;
    },
  },
  mounted() {
    let isWin = navigator.userAgent.indexOf("Windows") > -1;
    var $this = this;   
    /*****
     * 步骤2,初始化画布,设置画布,显示栅格*
     ******/
    let mainDiagram = this.$make(this.$go.Diagram, this.$refs.diagram, {
      isReadOnly: $this.isReadOnly || !$this.edit,
      //图的初始内容
      initialContentAlignment: this.$go.Spot.Default,
      //获取或设置选定对象的最大数目，默认值一个正整数
      // maxSelectionCount: 1,
      // 获取或设置用户是否可以调整零件大小
      allowResize: false,
      // 获取或设置用户是否可以旋转零件
      allowRotate: false,
      // 获取或设置用户是否可以进行就地文本编辑
      allowTextEdit: false,

      allowCopy: false,
      scrollMargin: new go.Margin(50, 100, 100, 100),
      // 'commandHandler.copiesTree': false,
      // 禁止鼠标拖动区域选
      // "dragSelectingTool.isEnabled": false,
      //画布网络
      grid: this.$make(
        this.$go.Panel,
        "Grid",
        this.$make(this.$go.Shape, "LineH", {
          stroke: "lightgray",
          strokeWidth: 0.2,
        }),
        this.$make(this.$go.Shape, "LineH", {
          stroke: "gray",
          strokeWidth: 0.2,
          interval: 10,
        }),
        this.$make(this.$go.Shape, "LineV", {
          stroke: "lightgray",
          strokeWidth: 0.2,
        }),
        this.$make(this.$go.Shape, "LineV", {
          stroke: "gray",
          strokeWidth: 0.2,
          interval: 10,
        }),
        { gridCellSize: new go.Size(20, 20) },
      ),
      //draggingTool为拖拽工具，获取或者设置draggingTool是否将对象捕捉到网格点
      "draggingTool.isGridSnapEnabled": true,
      //获取或者设置调整大小工具是否在调整大小期间将对象大小捕捉到关系图的背景网格
      "resizingTool.isGridSnapEnabled": true,
      "linkingTool.portGravity": 20,
      "relinkingTool.portGravity": 20,
      "rotatingTool.handleAngle": 270,
      "rotatingTool.handleDistance": 30,
      "rotatingTool.snapAngleMultiple": 15,
      "rotatingTool.snapAngleEpsilon": 15,
      "toolManager.hoverDelay":400,//提示显示延时时间
      "undoManager.isEnabled": true,
      // "linkingTool.temporaryLink": this.$make(
      //   this.$go.Link,
      //   { layerName: "Tool" },
      //   this.$make(this.$go.Shape, {
      //     stroke: "red",
      //     strokeWidth: 2,
      //     strokeDashArray: [4, 2],
      //   })
      // ),
      'linkingTool.temporaryLink': this.$make(this.$go.Link,
         { layerName: 'Tool' },
          this.$make(this.$go.Shape, {
              stroke: '#646363', 
          },
        ),
        this.$make(this.$go.Shape, {
              toArrow: 'Standard'
          },
        )
      ),
      //连线节点，等待，合并，抽取isValidLink链接是否有效
      //merge是合并节点，await是等待节点，msg是发送短信节点，intersection是交集节点，exclude排除节点，unique排重节点
      //isValidLink在逻辑上有效的将新链接从一个节点/端口链接到另一个节点端口
      "linkingTool.isValidLink": function(fromnode, fromport, tonode, toport) {
        if ($this.edit) {
          //连线节点，等待，合并，抽取
          //merge是合并节点，await是等待节点，msg是发送短信节点，intersection是交集节点，exclude排除节点，unique排重节点
          //findNodesInto查找节点的上一级节点 findNodesOutOf查找节点的下一级节点
          let relation = {
            await: { msg: 1 },
            crowd: {
              merge: 1,
              extraction: 1,
              intersection: 1,
              exclude: 1,
              unique: 1,
              msg: 1,
              await: 1,
            },
            vip: {
              merge: 1,
              extraction: 1,
              intersection: 1,
              exclude: 1,
              unique: 1,
              msg: 1,
              await: 1,
            },
            senior: {
              merge: 1,
              extraction: 1,
              intersection: 1,
              exclude: 1,
              unique: 1,
              msg: 1,
              await: 1,
            },
            order: {
              merge: 1,
              extraction: 1,
              intersection: 1,
              exclude: 1,
              unique: 1,
              msg: 1,
              await: 1,
            },
            specific: {
              merge: 1,
              extraction: 1,
              intersection: 1,
              exclude: 1,
              unique: 1,
              msg: 1,
              await: 1,
            },
            merge: {
              msg: 1,
              exclude: 1,
              extraction: 1,
              intersection: 1,
              unique: 1,
              await: 1,
            }, //合并链接点判断是否可以链接，新改写法
            extraction: {}, //原来写法，抽取
            intersection: {
              msg: 1,
              await: 1,
              exclude: 1,
              extraction: 1,
              unique: 1,
              merge: 1,
            },
            targetGroups: { msg: 1, await: 1, extraction: 1 },
            exclude: {
              msg: 1,
              await: 1,
              merge: 1,
              extraction: 1,
              intersection: 1,
              unique: 1,
              exclude:1
            },
            unique: {}, //排重，原来的写法
            msg: { analyze: 1, marketing: 1 },
            marketing: { msg: 1, await: 1 },
            analyze: {},
          };
          console.log(fromnode.data.category);
          if (
            fromnode.data.category === "await" &&
            tonode.findNodesInto().count === 1
          ) {
            return !1;
          }
          if (
            tonode.data.category === "await" &&
            tonode.findNodesInto().count === 1
          ) {
            return !1;
          }
          if (
            fromnode.data.category === "marketing" &&
            fromnode.findNodesOutOf().count === 1
          ) {
            return !1;
          }
          if (!this.isLinked(fromport, toport)) {
            if (tonode.data.category === "specific") {
              return !1;
            }
          }
          if (
            tonode.data.category === "extraction" &&
            tonode.findNodesInto().count === 1
          ) {
            return !1;
          }
          if (
            tonode.data.category === "unique" &&
            tonode.findNodesInto().count === 20
          ) {
            return !1;
          }
          if (
            tonode.data.category === "msg" &&
            tonode.findNodesInto().count === 1
          ) {
            return !1;
          }
          if (
            tonode.data.category === "marketing" &&
            tonode.findNodesInto().count === 1
          ) {
            return !1;
          }
          if (
            tonode.data.category === "analyze" &&
            tonode.findNodesInto().count === 1
          ) {
            return !1;
          }
          if (
            tonode.data.category === "exclude" &&
            tonode.findNodesInto().count === 2
          ) {
            return !1;
          }
          return (
            relation[fromnode.data.category][tonode.data.category] &&
            !this.isLinked(fromport, toport) &&
            !this.isInSameNode(fromport, toport)
          );
        } else {
          return false;
        }
      },
      // 数据发生变化
      ModelChanged: function(e) {
        $this.$emit("model-changed", e);
      },
      //选择数据发生变化
      ChangedSelection: function(e) {
        $this.$emit("changed-selection", e);
      },
      //双击事件
      ObjectDoubleClicked: function(e) {
        $this.$emit("object-double-clicked", e);
      },
        //鼠标选择事件
      SelectionMoved:function (e) { 
         $this.$emit('select-tion-moved', e)              
      },
      SelectionDeleting: function(e) {
        if ($this.edit) {
          //获取第一个选中的节点或者线
          let node = e.diagram.selection.first();
          if (node instanceof $this.$go.Link) {
            let to = node.data.to;
            //限制删除目标人群的链接，gojs模型数据包含两种
            //GraphLinksModel包含nodeDataArray和linkDataArray属性
            //somne依次执行数组的每个元素，item为删除的节点或者线
            if (
              !e.diagram.model.nodeDataArray.some((item) => {
                if (
                  item.smartMarketingNodeId === to &&
                  item.category === "targetGroups"
                ) {
                  $this.$message.error(
                    "目标人群链接不允许单独删除！请删除节点"
                  );
                  e.cancel = true;
                  return true;
                }
              })
            ) {
              $this.$emit("object-delete", e);
            }
          } else {
            $this.$emit("object-delete", e);
          }
        } else {
          //非编辑情况下阻止删除
          e.cancel = true;
        }
      },
      //删除对象前
      LinkDrawn: function(e) {
        $this.$emit("LinkDrawn", e);
      },
      //e.cancel = true为拦截删除的功能，gojs2.0以后，可能不支持通过另外一种方式实现，
      //重写键盘工具类commandHandler的canDeleteSelection，去拦截调用deleteSelection 实现取消删除的功能
      /**
       * myDiagram.commandHandler.canDeleteSelection = function(e) { 
		     	//用例获取选中的节点或线 
	     		return myDiagram.selection.all(function(nodeOrLink) { 
		  		console.log(nodeOrLink.data); 
			  	//判断是否存在不允许删除的节点或线 
			  	if(nodeOrLink.data.text=="勘察设计"){ 
				   	console.log("根存在不允许删除的节点，取消删除"); 
				  	return false; 
				  }else{ 
					  return true; 
				  } 
			   });  
       ***/
    });
    // mainDiagram.toolManager.dragSelectingTool.RealtimeDragSelectingTool.doMouseMove();

    // mainDiagram.toolManager.RealtimeDragSelectingTool.insertAt(new doMouseMove());
    mainDiagram.toolManager.dragSelectingTool.box =
      this.$make(go.Part,{ layerName: "Tool", selectable: false },
      this.$make(go.Shape,
        { name: "SHAPE", 
          fill: null, 
          stroke: "rgb(254, 77, 69)", 
          strokeWidth: 1 })
      );
    //画布外整体的长和宽
    this.$data.width = window.innerWidth - 320;
    this.$data.height = window.innerHeight - (isWin ? 218 : 142);
    window.onresize = () => {
      return (() => {
        this.$data.width = window.innerWidth - 320;
        this.$data.height = window.innerHeight - (isWin ? 218 : 142);
      })();
    };
    /*****
     * 步骤3,创建模型数据(Model)*
     * myModel.nodeDataArray = [{ key: "工厂" },{ key: "车间" },{ key: "工人" },{ key: "岗位" },];
     * mainDiagram.model=myModel
     ******/
    //显示图片,在节点模板那里可以应用到
    function convertKeyImage(category) {
      // eslint-disable-next-line
      // var img = '/assets/images/icon/seniorq.png'
      return require("@/assets/imagesZhi/icon/" + category + ".png");
    }
    //提示信息
   function diagramInfo(val) {
      return val;
    }
    //执行状态,这个状态由后端返回,前边带路径
    function statusImage(val) {
      let image = "";
      switch (true) {
        case val === 1 || val === 3:
          // eslint-disable-next-line
          // image = "/images/loading.png";
          image = require("@/assets/imagesZhi/loading.png");
          break;
        case val === 2 || val === 4:
          // eslint-disable-next-line
          image = require("@/assets/imagesZhi/true.png");
          break;
        case val === 5:
          // eslint-disable-next-line
          image = require("@/assets/imagesZhi/close.png");
          break;
      }
      return image;
    }
    /*****
     * 创建节点边框的四个小点,定义一个函数来创建的点(端口)，端口在节点上的位置，通过
     * 布尔"output"和"input"的参数，控制用户是否可以从端口到端口的链接
     ******/
    let makePort = function(name, spot, output, input) {
      return $this.$make(go.Shape, "Circle", {
        fill: null, //设置填充
        stroke: null, //设置轮廓
        desiredSize: new $this.$go.Size(7, 7), //设置大小
        alignment: spot, //元素位置设置
        alignmentFocus: spot,
        portId: name,
        fromSpot: spot,
        toSpot: spot,
        fromLinkable: output,
        toLinkable: input,
        cursor: "pointer",
      });
    };
    //显示点点，边框的四个小红点
    let showSmallPorts = function(node, show) {
      node.ports.each(function(port) {
        if (port.portId !== "") {
          // don't change the default port, which is the big shape
          if (port.portId === "linkShape") {
            port.stroke = show ? "deepskyblue" : null;
          } else {
            port.fill = show ? "red" : null;
          }
        }
      });
    };
    //鼠标点击，选中状态
    mainDiagram.nodeSelectionAdornmentTemplate = this.$make(
      this.$go.Adornment,
      "Auto",
      this.$make(this.$go.Shape, {
        fill: null,
        stroke: "deepskyblue",
        strokeWidth: 1.5,
        strokeDashArray: [4, 2],
      }),
      this.$make(this.$go.Placeholder)
    );
    //节点模板
    mainDiagram.nodeTemplate = this.$make(
      this.$go.Node,
      "Auto",
      { resizable:true },
      {
        locationSpot: this.$go.Spot.Center,
        locationObjectName: "SHAPE",
        layerName: "Background",
        fromSpot: this.$go.Spot.Right,
        toSpot: this.$go.Spot.Left,
      },
      {
        toolTip:                  
            this.$make(this.$go.Adornment, "Spot",{ background: "transparent" }, 
            this.$make(this.$go.Placeholder, { padding: 5 }),
            this.$make(this.$go.TextBlock,
                       {alignment: go.Spot.Top, 
                        alignmentFocus: go.Spot.Bottom, 
                        cursor: "pointer",
                        stroke: "red" },
                        new go.Binding("text", "errorDesc", diagramInfo)),
            // this.$make(this.$go.TextBlock, "Bottom",
            // { alignment: go.Spot.Bottom, alignmentFocus: go.Spot.Top, stroke: "red" },
            // new go.Binding("text", "color", function(s) { return "color: " + s; }))
          ) 
      },
      //绑定在location，才不会添加节点的时候，图标自动到左上角去
      new this.$go.Binding(
        "location",
        "coordinate",
        this.$go.Point.parse
      ).makeTwoWay(this.$go.Point.stringify),
      // 链接
      this.$make(this.$go.Shape, {
        fill: "transparent",
        stroke: null,
        fromLinkable: true,
        toLinkable: true,
        portId: "linkShape",
        cursor: "pointer",
        strokeWidth: 1.5,
        strokeDashArray: [4, 2],
      }),
      // four small named ports, one on each side:
      // makePort("T", go.Spot.Top, false, true),
      makePort("L", go.Spot.Left, true, true),
      makePort("R", go.Spot.Right, true, true),
      // makePort("B", go.Spot.Bottom, true, false),
      {
        // handle mouse enter/leave events to show/hide the ports
        mouseEnter: function(e, node) {
          showSmallPorts(node, true);
        },
        mouseLeave: function(e, node) {
          showSmallPorts(node, false);
        },
      },
      // 面板
      this.$make(
        this.$go.Panel,
        "Vertical",
        // 节点更新文字
        this.$make(
          this.$go.TextBlock,
          {
            font: "11px 微软雅黑",
            margin: 7,
            maxSize: new this.$go.Size(80, NaN),
            wrap: this.$go.TextBlock.WrapFit,
            stroke: "#627085",
          },
          new this.$go.Binding("text", "resultCount")
        ),
        this.$make(
          this.$go.Panel,
          this.$go.Panel.Position,
          // 状态图标
          this.$make(
            this.$go.Picture,
            {
              desiredSize: new this.$go.Size(13, 13),
              position: new this.$go.Point(45, 0),      
            },
            new this.$go.Binding("source", "executionStatus", statusImage)
          ),
          // 主图像
          this.$make(
            this.$go.Picture,
            {
              desiredSize: new this.$go.Size(45, 45),
              position: new this.$go.Point(6, 0),
            },
            new this.$go.Binding("source", "category", convertKeyImage)
          )
        ),
        // 名称文字
        this.$make(
          this.$go.TextBlock,
          {
            font: "14px 微软雅黑",
            margin: 8,
            maxSize: new this.$go.Size(70, NaN),
            minSize: new this.$go.Size(70, NaN),
            textAlign:"center",
            wrap: this.$go.TextBlock.WrapFit,
          },
          new this.$go.Binding("stroke", "isSaveContent", (val) => {
            console.log(val);
            return val ? "#627085" : "red";
          }),
          new this.$go.Binding("text")
        )
      )
    );
    //链接模板
    mainDiagram.linkTemplate = this.$make(
      this.$go.Link,
      {
        routing: this.$go.Link.AvoidsNodes, //链接线避开节点
        corner: 8, //直角弧度
        curve: this.$go.Link.JumpOver,
        reshapable: true, // 允许线形修改
        // 鼠标移到连线上后高亮，自己加的效果
        // mouseEnter: function(e, link) { link.findObject("HIGHLIGHT").stroke = "rgba( 52, 52, 52,0.1)"; },
        // mouseLeave: function(e, link) { link.findObject("HIGHLIGHT").stroke = "transparent"; },
        // selectionAdorned: false
      },
      //  this.$make(this.$go.Shape,  // 隐藏的连线形状，8个像素粗细，当鼠标移上后显示
      //  { isPanelMain: true, strokeWidth: 6, stroke: "transparent", name: "HIGHLIGHT" }),
      this.$make(
        this.$go.Shape,
        { isPanelMain: true, stroke: "gray", strokeWidth: 1 },
        new this.$go.Binding("stroke", "isSelected", function(sel) {
          return sel ? "dodgerblue" : "gray";
        }).ofObject()
      ),
      this.$make(this.$go.Shape, {
        toArrow: "standard",
        strokeWidth: 1,
        stroke: "gray",
        fill: "gray",
      })
    );
    /*****
     * 步骤4,,数据才能获取显示*
     ******/
    this.diagram = mainDiagram;
    //预览小图
    this.overview = this.$make(this.$go.Overview, this.$refs.overview, {
      observed: mainDiagram,
      contentAlignment: this.$go.Spot.Center,
    });
    // 更新数据
    this.updateModel(this.modelData);
  },
  methods: {
    model() {
      return this.diagram.model;
    },
    getDiagram() {
      return this.diagram;
    },
    updateModel(val) {
      if (val instanceof this.$go.Model) {
        this.diagram.model = val;
      } else {
        var m = new this.$go.GraphLinksModel();
        if (val) {
          for (var p in val) {
            m[p] = val[p];
          }
        }
        this.diagram.model = m;
      }
    },
    updateDiagramFromData() {
      //刷新用到
      this.diagram.startTransaction();
      this.diagram.updateAllRelationshipsFromData();
      this.diagram.updateAllTargetBindings();
      this.diagram.commitTransaction("updated");
    },
  },
};
</script>

<style lang="less">
.diagram {
  position: relative;
  .overview {
    position: absolute;
    width: 576px;
    height: 335px;
    top: 0px;
    right: 10px;
    background-color: aliceblue;
    z-index: 300;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.16);
  }
}
</style>
